// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1kLFN","error":"InputSecondary_error__2taDY","disabled":"InputSecondary_disabled__KNmai"};